import { Component } from '@angular/core';

import { of } from 'rxjs';

import { register } from 'swiper/element/bundle';

import { QuickActionsCustomComponent } from '@camelot/menu';
import { SwiperComponent, SwiperData } from '@camelot/ui';

import { TestIdDirective } from '@camelot/testing-harness';

register();

@Component({
    imports: [QuickActionsCustomComponent, SwiperComponent, TestIdDirective],
    template: `
    <cam-swiper camTestId="cam-swiper" [slides]="this.slides" [swipeTemplate]="slideTemplate" />
    <cam-quick-actions-custom
      camTestId="cam-quick-actions-custom"
      [elements]="this.slides"
      [swipeTemplate]="slideTemplate"
    />
    <ng-template #slideTemplate let-key="key">
      <div>slide {{ key }}</div>
    </ng-template>
  `
})
export class UiSwiperCase {
  public slides: SwiperData[] = [
    { key: 'one', visible$: of(true) },
    { key: 'two', visible$: of(true) },
  ];
}
